// valentines week confetti version with hear symbols and a custom drawShape for a more festive look. This version is a bit more complex due to the timer management to ensure confetti only fires once per success and doesn't have edge cases with multiple uploads in a row, but it has a nicer visual effect and is still performant with 200 pieces and optimized physics settings.

// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { useNavigate } from 'react-router-dom';
// import Confetti from 'react-confetti';

// const UploadForm = ({
//   categories,
//   types,
//   counties,
//   isAdmin,
//   files,
//   attachmentCategoryID,
//   attachmentTypeID,
//   countyId,
//   description,
//   isLoading,
//   message,
//   uploadSuccess,
//   styles,
//   handleCategoryChange,
//   setAttachmentTypeID,
//   setCountyId,
//   setDescription,
//   setFiles,
//   handleSubmit,
//   handleCancel,
//   handleRemoveFile,
//   uploadProgress,
//   // new: parent can request a fresh form after success
//   onUploadAgain,
// }) => {
//   const navigate = useNavigate();

//   // ----- Dropzone (unchanged) -----
//   const { getRootProps, getInputProps } = useDropzone({
//     accept: {
//       'application/pdf': ['.pdf'],
//       'image/*': ['.png', '.jpg', '.jpeg', '.tif', '.tiff'],
//       'application/msword': ['.doc'],
//       'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
//       'application/vnd.ms-excel': ['.xls'],
//       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
//       'message/rfc822': ['.eml'],
//     },
//     multiple: true,
//     onDrop: (acceptedFiles) => {
//       const validFiles = [];
//       acceptedFiles.forEach(file => {
//         if (file.size > 50 * 1024 * 1024) {
//           alert(`${file.name} exceeds the limit.Please upload a file less than 50MB`);
//         } else {
//           validFiles.push(file);
//         }
//       });
//       setFiles(prev => [...prev, ...validFiles]);
//     }
//   });

//   // ----- One-time confetti control -----
//   const [showConfetti, setShowConfetti] = useState(false);
//   const [vw, setVw] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
//   const [vh, setVh] = useState(typeof window !== 'undefined' ? window.innerHeight : 800);
//   const confettiTimerRef = useRef(null);

//   const clearConfettiTimer = useCallback(() => {
//     if (confettiTimerRef.current) {
//       clearTimeout(confettiTimerRef.current);
//       confettiTimerRef.current = null;
//     }
//   }, []);

//   useEffect(() => {
//     if (typeof window === 'undefined') return undefined;

//     const onResize = () => {
//       setVw(window.innerWidth);
//       setVh(window.innerHeight);
//     };

//     window.addEventListener('resize', onResize);
//     return () => window.removeEventListener('resize', onResize);
//   }, []);

//   const fireConfetti = useCallback(() => {
//     setShowConfetti(true);
//     clearConfettiTimer();
//     confettiTimerRef.current = setTimeout(() => setShowConfetti(false), 8000);
//   }, [clearConfettiTimer]);

//   // when uploadSuccess flips true, fire confetti briefly, then stop
//   useEffect(() => {
//     if (uploadSuccess) fireConfetti();
//     return () => {
//       clearConfettiTimer();
//     };
//   }, [uploadSuccess, fireConfetti, clearConfettiTimer]);

//   // ----- Success Screen -----
//   if (uploadSuccess) {
//     return (
//       <div style={{ ...styles.formContainer, position: 'relative', overflow: 'hidden' }}>
//         {showConfetti && (
//           <Confetti
//             width={vw}
//             height={vh}
//             numberOfPieces={200}
//             recycle={false}           // important: don't loop
//             gravity={0.045}           // balanced fall speed
//             wind={0.002}              // subtle drift
//             initialVelocityY={7}
//             initialVelocityX={3}
//             tweenDuration={9000}
//             colors={['#be123c', '#e11d48', '#fb7185', '#fecdd3', '#fff7f9']}
//             drawShape={(ctx) => {
//               ctx.beginPath();
//               ctx.moveTo(0, -12);
//               ctx.bezierCurveTo(12, -24, 24, -6, 0, 18);
//               ctx.bezierCurveTo(-24, -6, -12, -24, 0, -12);
//               ctx.closePath();
//               ctx.fill();
//             }}
//           />
//         )}

//         <div
//           style={{
//             background: '#ffffff',
//             border: '1px solid #e5e7eb',
//             borderRadius: 12,
//             padding: 24,
//             boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//             textAlign: 'center'
//           }}
//         >
//           {/* green check */}
//           <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: 999, background: '#ecfdf5', marginBottom: 12 }}>
//             <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//               <path d="M20 6L9 17l-5-5" />
//             </svg>
//           </div>

//           <h2 style={{ margin: '6px 0 4px', fontSize: 22, fontWeight: 700, color: '#111827' }}>
//             Upload successful!
//           </h2>

//           <div aria-live="polite">
//             {message && (
//               <p style={{ marginTop: 8, color: '#374151' }}>
//                 {message}
//               </p>
//             )}
//           </div>

//           <div style={{ marginTop: 16, display: 'grid', gap: 8 }}>
//             <p style={{ margin: 0, color: '#111827' }}>
//               If you want to upload again,{' '}
//               <button
//                 type="button"
//                 onClick={() => {
//                   clearConfettiTimer();
//                   onUploadAgain();
//                 }}
//                 style={{
//                   appearance: 'none',
//                   background: 'transparent',
//                   color: '#2563eb',
//                   fontWeight: 600,
//                   border: 'none',
//                   padding: 0,
//                   cursor: 'pointer',
//                   textDecoration: 'underline'
//                 }}
//               >
//                  Click here
//               </button>.
//             </p>
//             <p style={{ margin: 0, color: '#111827' }}>
//               View uploaded documents,{' '}
//               <button
//                 type="button"
//                 onClick={() => {
//                   clearConfettiTimer();
//                   navigate('/home');
//                 }}
//                 style={{
//                   appearance: 'none',
//                   background: 'transparent',
//                   color: '#2563eb',
//                   fontWeight: 600,
//                   border: 'none',
//                   padding: 0,
//                   cursor: 'pointer',
//                   textDecoration: 'underline'
//                 }}
//               >
//                 Click here
//               </button>.
//             </p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ----- Original Form (unchanged logic) -----
//   return (
//     <div style={styles.formContainer}>
//       <form onSubmit={handleSubmit} style={styles.form}>
//         <div style={{ marginBottom: 12, padding: '8px 12px', background: '#f1f5f9', borderRadius: 8, color: '#dc2626', fontSize: 18, textAlign: 'center', fontWeight: 600 }}>
//           Note: You can upload multiple documents. Each file must be under 50MB. Accepted formats: PDF, PNG, JPG, JPEG, TIF, TIFF, DOC, DOCX, XLS, XLSX, EML.
//         </div>

//         <div style={styles.formGroup}>
//           <label style={styles.label}>Attachment Category <span style={{ color: '#dc143c' }}>*</span></label>
//           <select
//             value={attachmentCategoryID}
//             onChange={handleCategoryChange}
//             style={styles.input}
//             required
//           >
//             <option value="">Select a category</option>
//             {categories.map(c => (
//               <option key={c.ID} value={c.ID}>{c.Name}</option>
//             ))}
//           </select>
//         </div>

//         <div style={styles.formGroup}>
//           <label style={styles.label}>Attachment Type <span style={{ color: '#dc143c' }}>*</span></label>
//           <select
//             value={attachmentTypeID}
//             onChange={(e) => setAttachmentTypeID(e.target.value)}
//             style={styles.input}
//             required
//           >
//             <option value="">Select a type</option>
//             {types && types.map(t => (
//               <option key={t.ID} value={t.ID}>{t.Name}</option>
//             ))}
//           </select>
//         </div>

//         {isAdmin && counties.length > 0 && (
//           <div style={styles.formGroup}>
//             <label style={styles.label}>Select County <span style={{ color: '#dc143c' }}>*</span></label>
//             <select
//               value={countyId}
//               onChange={(e) => setCountyId(e.target.value)}
//               style={styles.input}
//               required
//             >
//               <option value="">Select a County</option>
//               {counties.map(county => (
//                 <option key={county.CountyID} value={county.CountyID}>{county.Name}</option>
//               ))}
//             </select>
//           </div>
//         )}

//         <div style={styles.formGroup}>
//           <label style={styles.label}>Description (max 100 words) <span style={{ color: '#dc143c' }}>*</span></label>
//           <textarea
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             style={styles.textarea}
//             rows={2}
//             required
//           />
//         </div>

//         <div style={styles.formGroup}>
//           <label style={styles.label}>Upload Files <span style={{ color: '#dc143c' }}>*</span></label>
//           <div {...getRootProps()} style={styles.dropzone}>
//             <input {...getInputProps()} />
//             <p>Drag & drop files here, or click to select</p>
//           </div>
//           <ul style={styles.fileList}>
//             {files.map((file, index) => (
//               <li key={index} style={styles.fileItem}>
//                 <span>{file.name}</span>
//                 {uploadProgress[file.name] != null && (
//                   <div style={styles.progressBarContainer}>
//                     <div style={{ ...styles.progressBar, width: `${uploadProgress[file.name]}%` }}></div>
//                   </div>
//                 )}
//                 <button
//                   type="button"
//                   onClick={() => handleRemoveFile(index)}
//                   style={styles.removeButton}
//                 >
//                   ✕
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div style={styles.formActions}>
//           <button
//             type="submit"
//             disabled={isLoading}
//             style={isLoading ? styles.buttonDisabled : styles.button}
//           >
//             {isLoading ? 'Uploading...' : 'Upload Files'}
//           </button>
//           <button
//             type="button"
//             onClick={handleCancel}
//             style={styles.cancelButton1}
//           >
//             Cancel
//           </button>
//         </div>
//       </form>

//       {message && (
//         <div style={uploadSuccess ? styles.success : styles.error}>
//           {message}
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadForm;















































// Regular confetti version, simpler and more lightweight, without the timer management (confetti just fires for a fixed 3s on success, no need to manually clear timers or worry about edge cases):


import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';

const UploadForm = ({
  categories,
  types,
  counties,
  isAdmin,
  files,
  attachmentCategoryID,
  attachmentTypeID,
  countyId,
  description,
  appraisalYear,
  setAppraisalYear,
  isAdminOnly,
  setIsAdminOnly,
  isLoading,
  message,
  uploadSuccess,
  styles,
  handleCategoryChange,
  setAttachmentTypeID,
  setCountyId,
  setDescription,
  setFiles,
  handleSubmit,
  handleCancel,
  handleRemoveFile,
  uploadProgress,
  // new: parent can request a fresh form after success
  onUploadAgain,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2018 }, (_, i) => 2019 + i);
  const navigate = useNavigate();

  // ----- Dropzone (unchanged) -----
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': ['.png', '.jpg', '.jpeg', '.tif', '.tiff'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      // allow zipped bundles of documents
      'application/zip': ['.zip'],
      'application/x-zip-compressed': ['.zip'],
      'message/rfc822': ['.eml'],
    },
    multiple: true,
    onDrop: (acceptedFiles) => {
      const validFiles = [];
      acceptedFiles.forEach(file => {
        if (file.size > 50 * 1024 * 1024) {
          alert(`${file.name} exceeds the limit.Please upload a file less than 50MB`);
        } else {
          validFiles.push(file);
        }
      });
      setFiles(prev => [...prev, ...validFiles]);
    }
  });

  // ----- One-time confetti control -----
  const [showConfetti, setShowConfetti] = useState(false);
  const [vw, setVw] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [vh, setVh] = useState(typeof window !== 'undefined' ? window.innerHeight : 800);

  useEffect(() => {
    const onResize = () => {
      setVw(window.innerWidth);
      setVh(window.innerHeight);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // when uploadSuccess flips true, fire confetti briefly, then stop
  useEffect(() => {
    if (!uploadSuccess) return;
    setShowConfetti(true);
    const t = setTimeout(() => setShowConfetti(false), 3000); // confetti for ~2.5s
    return () => clearTimeout(t);
  }, [uploadSuccess]);

  // ----- Success Screen -----
  if (uploadSuccess) {
    return (
      <div style={{ ...styles.formContainer, position: 'relative', overflow: 'hidden' }}>
        {showConfetti && (
          <Confetti
            width={vw}
            height={vh}
            numberOfPieces={320}
            recycle={false}          // important: don't loop
            gravity={0.18}
          />
        )}

        <div
          style={{
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            padding: 24,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            textAlign: 'center'
          }}
        >
          {/* green check */}
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: 999, background: '#ecfdf5', marginBottom: 12 }}>
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>

          <h2 style={{ margin: '6px 0 4px', fontSize: 22, fontWeight: 700, color: '#111827' }}>
            Upload successful!
          </h2>

          {message && (
            <p style={{ marginTop: 8, color: '#374151' }}>
              {message}
            </p>
          )}

          <div style={{ marginTop: 16, display: 'grid', gap: 8 }}>
            <p style={{ margin: 0, color: '#111827' }}>
              If you want to upload again,{' '}
              <button
                type="button"
                onClick={onUploadAgain}
                style={{
                  appearance: 'none',
                  background: 'transparent',
                  color: '#2563eb',
                  fontWeight: 600,
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                 Click here
              </button>.
            </p>
            <p style={{ margin: 0, color: '#111827' }}>
              View uploaded documents,{' '}
              <button
                type="button"
                onClick={() => navigate('/home')}
                style={{
                  appearance: 'none',
                  background: 'transparent',
                  color: '#2563eb',
                  fontWeight: 600,
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                Click here
              </button>.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // ----- Original Form (unchanged logic) -----
  return (
    <div style={styles.formContainer}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={{ marginBottom: 12, padding: '8px 12px', background: '#f1f5f9', borderRadius: 8, color: '#dc2626', fontSize: 18, textAlign: 'center', fontWeight: 600 }}>
          Note: You can upload multiple documents. Each file must be under 50MB. Accepted formats: PDF, PNG, JPG, JPEG, TIF, TIFF, DOC, DOCX, XLS, XLSX, EML, ZIP.
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Attachment Category <span style={{ color: '#dc143c' }}>*</span></label>
          <select
            value={attachmentCategoryID}
            onChange={handleCategoryChange}
            style={styles.input}
            required
          >
            <option value="">Select a category</option>
            {categories.map(c => (
              <option key={c.ID} value={c.ID}>{c.Name}</option>
            ))}
          </select>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Attachment Type <span style={{ color: '#dc143c' }}>*</span></label>
          <select
            value={attachmentTypeID}
            onChange={(e) => setAttachmentTypeID(e.target.value)}
            style={styles.input}
            required
          >
            <option value="">Select a type</option>
            {types && types.map(t => (
              <option key={t.ID} value={t.ID}>{t.Name}</option>
            ))}
          </select>
        </div>

        {isAdmin && counties.length > 0 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Select County <span style={{ color: '#dc143c' }}>*</span></label>
            <select
              value={countyId}
              onChange={(e) => setCountyId(e.target.value)}
              style={styles.input}
              required
            >
              <option value="">Select a County</option>
              {counties.map(county => (
                <option key={county.CountyID} value={county.CountyID}>{county.Name}</option>
              ))}
            </select>
          </div>
        )}

        {isAdmin && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Appraisal Year <span style={{ color: '#dc143c' }}>*</span></label>
            <select
              value={appraisalYear}
              onChange={(e) => setAppraisalYear(e.target.value)}
              style={styles.input}
              required
            >
              {years.map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        )}

        {isAdmin && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Access <span style={{ color: '#dc143c' }}>*</span></label>
            <div style={{ display: 'flex', gap: 24, marginTop: 4 }}>
              {[{ label: 'Client', value: '0' }, { label: 'Internal', value: '1' }].map(opt => (
                <label key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontWeight: 500, fontSize: 14, color: '#374151' }}>
                  <input
                    type="radio"
                    name="visibility"
                    value={opt.value}
                    checked={isAdminOnly === opt.value}
                    onChange={(e) => setIsAdminOnly(e.target.value)}
                    required
                    style={{ accentColor: '#4A628A', width: 16, height: 16 }}
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          </div>
        )}

        <div style={styles.formGroup}>
          <label style={styles.label}>Description (max 100 words) <span style={{ color: '#dc143c' }}>*</span></label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={styles.textarea}
            rows={2}
            required
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Upload Files <span style={{ color: '#dc143c' }}>*</span></label>
          <div {...getRootProps()} style={styles.dropzone}>
            <input {...getInputProps()} />
            <p>Drag & drop files here, or click to select</p>
          </div>
          <ul style={styles.fileList}>
            {files.map((file, index) => (
              <li key={index} style={styles.fileItem}>
                <span>{file.name}</span>
                {uploadProgress[file.name] != null && (
                  <div style={styles.progressBarContainer}>
                    <div style={{ ...styles.progressBar, width: `${uploadProgress[file.name]}%` }}></div>
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => handleRemoveFile(index)}
                  style={styles.removeButton}
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div style={styles.formActions}>
          <button
            type="submit"
            disabled={isLoading}
            style={isLoading ? styles.buttonDisabled : styles.button}
          >
            {isLoading ? 'Uploading...' : 'Upload Files'}
          </button>
          <button
            type="button"
            onClick={handleCancel}
            style={styles.cancelButton1}
          >
            Cancel
          </button>
        </div>
      </form>

      {message && (
        <div style={uploadSuccess ? styles.success : styles.error}>
          {message}
        </div>
      )}
    </div>
  );
};

export default UploadForm;

